import { initFirebase } from '../firebase'
import { collection, getDocs, query, orderBy, doc, getDoc, deleteDoc, updateDoc } from 'firebase/firestore'

const { db } = initFirebase()

export class FirebaseFeedbackService {
  constructor() {}

  async getAllFeedbacks() {
    try {
      const feedbacksRef = collection(db, 'feedback')
      const q = query(feedbacksRef, orderBy('timestamp', 'desc'))
      const querySnapshot = await getDocs(q)
      return querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }))
    } catch (error) {
      console.error('Error fetching feedbacks:', error)
      throw error
    }
  }

  async getFeedbackById(feedbackId) {
    try {
      const feedbackRef = doc(db, 'feedback', feedbackId)
      const feedbackDoc = await getDoc(feedbackRef)
      if (feedbackDoc.exists()) {
        return {
          id: feedbackDoc.id,
          ...feedbackDoc.data()
        }
      }
      return null
    } catch (error) {
      console.error('Error fetching feedback:', error)
      throw error
    }
  }

  async deleteFeedback(feedbackId) {
    try {
      const feedbackRef = doc(db, 'feedback', feedbackId)
      await deleteDoc(feedbackRef)
    } catch (error) {
      console.error('Error deleting feedback:', error)
      throw error
    }
  }

  async updateRepliedBy(feedbackId, repliedBy) {
    try {
      const feedbackRef = doc(db, 'feedback', feedbackId)
      const updateData = { repliedBy }
      if (repliedBy) {
        updateData.repliedAt = new Date()
      } else {
        updateData.repliedAt = null
      }
      await updateDoc(feedbackRef, updateData)
      return updateData.repliedAt
    } catch (error) {
      console.error('Error updating repliedBy:', error)
      throw error
    }
  }

  async updateReplyNote(feedbackId, replyNote) {
    try {
      const feedbackRef = doc(db, 'feedback', feedbackId)
      await updateDoc(feedbackRef, { replyNote: replyNote || null })
    } catch (error) {
      console.error('Error updating replyNote:', error)
      throw error
    }
  }

  async updateResolved(feedbackId, resolved) {
    try {
      const feedbackRef = doc(db, 'feedback', feedbackId)
      await updateDoc(feedbackRef, { resolved: resolved })
    } catch (error) {
      console.error('Error updating resolved:', error)
      throw error
    }
  }

  async saveReply(feedbackId, repliedBy, replyNote) {
    try {
      const feedbackRef = doc(db, 'feedback', feedbackId)
      const repliedAt = repliedBy ? new Date() : null
      await updateDoc(feedbackRef, {
        repliedBy: repliedBy,
        replyNote: replyNote,
        repliedAt: repliedAt
      })
      return { repliedAt }
    } catch (error) {
      console.error('Error saving reply:', error)
      throw error
    }
  }
} 